var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.visible,
            width: _vm.width,
            "append-to-body": "",
            modal: "",
          },
          on: { close: _vm.handleCloes },
        },
        [
          _c("BjPage", {
            ref: "BjPage",
            attrs: {
              "get-action": _vm.queryApi,
              "query-params": _vm.queryParams,
              "col-span": _vm.colSpan,
              "search-btn-span": _vm.colSpan,
              serial: _vm.serial,
              "search-btn-hide": false,
              "before-reset-search": _vm.beforeResetSearch,
              height: 500,
            },
            scopedSlots: _vm._u([
              {
                key: "baseForm",
                fn: function () {
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("table.statusText") } },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                placeholder: _vm.$t("table.statusText"),
                                "option-list": _vm.IMPORT_STATUS,
                              },
                              on: { change: _vm.handleQuery },
                              model: {
                                value: _vm.queryParams.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "status", $$v)
                                },
                                expression: "queryParams.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("reasonText") } },
                          [
                            _c("BjInput", {
                              attrs: {
                                maxlength: _vm.MAX_LENGTH.REMARK,
                                placeholder: _vm.$t("reasonText"),
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleQuery.apply(null, arguments)
                                },
                              },
                              model: {
                                value: _vm.queryParams.errorReason,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "errorReason", $$v)
                                },
                                expression: "queryParams.errorReason",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "tableColumn",
                fn: function () {
                  return [
                    _vm._l(_vm.dropCols, function (col, index) {
                      return [
                        col.prop !== "bjTableAction"
                          ? _c("el-table-column", {
                              key:
                                "col_" +
                                index +
                                "_" +
                                col.prop +
                                "_" +
                                (col.width || "auto"),
                              attrs: {
                                prop: col.prop,
                                label: col.label,
                                width: col.width || "auto",
                                fixed: col.fixed || false,
                                align: "center",
                                "class-name": "item",
                                "show-overflow-tooltip":
                                  col.prop !== "bjTableAction",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        false
                                          ? void 0
                                          : col.prop === "dataStatus"
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.IMPORT_STATUS.bjGet(
                                                        scope.row.dataStatus
                                                      )
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("timeFilters")(
                                                    scope.row[col.prop],
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                      ]
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }